import {Box} from "@mui/material";
import {ContactInfo} from "./ContactInfo";

export const ContactInfoPage = () => {
  return (
    <Box maxWidth={"md"} sx={{mx: 'auto'}}>
      <ContactInfo />
    </Box>
  )
}